import type { PredictionParameters } from '~/types'

export type WarningsSchema = {
  [key in keyof PredictionParameters]?: (val: Required<PredictionParameters>[key]) => string | false
}

export default {
  ageAtAccident: (val) => {
    if (val === null)
      return false
    return val > 100 ? 'This value is outside of the normal parameters of the model' : false
  },
} as WarningsSchema
